var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardiac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7C8.94244 7 4 11.9424 4 18C4 22.0962 7.08764 25.9529 10.8516 29.9082C14.6155 33.8635 19.2484 37.8695 22.9395 41.5605C23.2208 41.8417 23.6022 41.9997 24 41.9997C24.3978 41.9997 24.7792 41.8417 25.0605 41.5605C28.7516 37.8695 33.3845 33.8635 37.1484 29.9082C40.9124 25.9529 44 22.0962 44 18C44 11.9424 39.0576 7 33 7C29.5236 7 26.4968 8.86649 24 12.0371C21.5032 8.86649 18.4764 7 15 7ZM15 10C17.9286 10 20.3663 11.5584 22.7324 15.3008C22.8677 15.5145 23.0549 15.6906 23.2765 15.8126C23.4981 15.9346 23.747 15.9986 24 15.9986C24.253 15.9986 24.5019 15.9346 24.7235 15.8126C24.9451 15.6906 25.1323 15.5145 25.2676 15.3008C27.6337 11.5584 30.0714 10 33 10C37.4364 10 41 13.5636 41 18C41 20.4038 38.5876 24.0471 34.9766 27.8418C31.6836 31.3022 27.5903 34.9175 24 38.418C20.4097 34.9175 16.3164 31.3022 13.0234 27.8418C9.41236 24.0471 7 20.4038 7 18C7 13.5636 10.5636 10 15 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiac);
export default __webpack_public_path__ + "static/media/cardiac.92e1b2560d163dd6d48095a7328807d6.svg";
export { ForwardRef as ReactComponent };